import 'css-chunksrc/client/scenes/optimizedGantt/header/moveToTodayButton/styles.scss';export default {
  "moveToTodayButton": "_moveToTodayButton_1hh29_1",
  "icon": "_icon_1hh29_14",
  "text": "_text_1hh29_19"
};